import { customersClubService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    customers_club_setting: {},

}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, data) {
        state.status = 'success'
        state.data = data
    },
    successFetchSetting(state, customers_club_setting) {
        state.status    = 'success'
        state.customers_club_setting = customers_club_setting
    },
    fail(state) {
        state.status = 'fail'
        state.data = []
        state.customers_club_setting = []
    },
}

const getters = {
    status: ({status}) => status,
    customers_club_setting: ({customers_club_setting}) => customers_club_setting,

}

const actions = {
    fetchSetting({commit}) {
        commit('loading')
        return customersClubService.fetch()
            .then(response => {
                commit('successFetchSetting', response.data.data)
            })
    },
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}
